import {
  CiRateCardRequest,
  DeleteFieldEditType,
  SimpleValueDateRangeType,
} from "../../../../app/models/requestModels/ClientInvoiceEditRequest";
import { UpdatePeakSurcharge } from "../../ratecard/dtos/UpdateRateCardRequest";
import {
  ClientInvoiceCustomFields,
  ClientInvoiceFuelSurchargeFields,
  ClientInvoiceFuelSurchargeLookup,
  DiscountDateRangeValue,
  EditClientInvoiceUIRequest,
  FuelSurchargeDateRangeValue,
} from "../ClientInvoiceInterfaces";
import {
  RatecardValueResponse
} from "../../ratecard/dtos/RateCardResponse";

export const mapValuesUiRequestToCiRatecard = (
  originalRatecardId: number,
  uiRequest: EditClientInvoiceUIRequest,
  originalValues: RatecardValueResponse,
  ciFuelSurchargeFields: ClientInvoiceFuelSurchargeFields[],
  ciFuelSurchargeLookups: ClientInvoiceFuelSurchargeLookup[],
  ciCustomFields: ClientInvoiceCustomFields[],
  ciPeakSurcharges: UpdatePeakSurcharge[]
): CiRateCardRequest => {
  const ratecard: CiRateCardRequest = {
    id: originalRatecardId,
    ratecardFuelSurchargeFields: [],
    ratecardFuelSurchargeLookup: [],
    ratecardCustomFields: [],
    ratecardPeakSurcharges: [],
  };
  if (uiRequest.baseRate !== originalValues.baseRate)
    ratecard.baseRate = uiRequest.baseRate;
  if (
    uiRequest.variableRate !== originalValues.variableRate ||
    uiRequest.variableRateType !== originalValues.variableRateType
  ) {
    ratecard.variableRate = uiRequest.variableRate;
    ratecard.variableRateType = uiRequest.variableRateType;
  }
  if (uiRequest.routeMinimum !== originalValues.routeMinimum)
    ratecard.routeMinimum = uiRequest.routeMinimum;
  if (
    uiRequest.lateCancellationCharge !==
      originalValues.lateCancellationCharge ||
    uiRequest.lateCancellationType !== originalValues.lateCancellationType
  ) {
    ratecard.lateCancellationCharge = uiRequest.lateCancellationCharge;
    ratecard.lateCancellationType = uiRequest.lateCancellationType;
  }
  // DISCOUNT
  if (uiRequest.show_discount) {
    if (uiRequest.discount_custom_value)
      ratecard.discountCustomValue = uiRequest.discount_custom_value;
    else {
      ratecard.discountType =
        uiRequest.discount_type === "volume"
          ? "volume"
          : uiRequest.discount_rate_type;
      // handle volume discount
      if (uiRequest.discount_type === "volume") {
        ratecard.discountMinVolumeRate = uiRequest.discount_volume_min_unit;
        ratecard.discountFrequency = mapFrequencyTextToNumber(
          `${uiRequest.discount_volume_frequency}`
        );
        if (uiRequest.discount_volume_unit_type === "percentage") {
          ratecard.discountUnitType = "percentage";
          ratecard.discountValue = uiRequest.discount_volume_value_percentage;
        } else {
          ratecard.discountUnitType = "value";
          ratecard.discountValue = uiRequest.discount_volume_value_dollar;
        }
      }
      // handle rate discount
      else if (uiRequest.discount_type === "rate") {
        ratecard.discountMinVolumeRate = uiRequest.discount_rate_min_unit;

        ratecard.discountFrequency = mapFrequencyTextToNumber(
          `${uiRequest.discount_rate_frequency}`
        );
        if (uiRequest.discount_rate_unit_type === "percentage") {
          ratecard.discountUnitType = "percentage";
          ratecard.discountValue = uiRequest.discount_rate_value_percentage;
        } else {
          ratecard.discountUnitType = "value";
          ratecard.discountValue = uiRequest.discount_rate_value_dollar;
        }
      }
    }
  }
  // TODO: when field level date range is added and plus button is clicked then reset all fuel surcharge values so that it is not read here as part of ratecard edit.
  // FUEL SURCHARGE
  if (uiRequest.show_fuel_surcharge) {
    if (uiRequest.fuel_surcharge_custom_value)
      ratecard.fuelCustomValue = uiRequest.fuel_surcharge_custom_value;
    else {
      if (uiRequest.fuelType !== originalValues.fuelType)
        ratecard.fuelType = uiRequest.fuelType;
      if (uiRequest.regionName !== originalValues.regionName)
        ratecard.regionName = uiRequest.regionName;
      ratecard.ratecardFuelSurchargeFields = ciFuelSurchargeFields;
      ratecard.ratecardFuelSurchargeLookup = ciFuelSurchargeLookups;
    }
  }

  if (uiRequest.show_custom_fields) {
   
     ratecard.ratecardCustomFields = ciCustomFields

    
  }
  // PEAK SURCHARGE
  if (uiRequest.show_peak_surcharge) {
    if (uiRequest.peak_surcharge_custom_value)
      ratecard.peakCustomValue = uiRequest.peak_surcharge_custom_value;
    else ratecard.ratecardPeakSurcharges = ciPeakSurcharges;
  }

  return ratecard;
};

// export const mapValuesUiRequestToCiRatecard = (
//   uiRequest: EditClientInvoiceUIRequest,
//   ciFuelSurchargeFields: ClientInvoiceFuelSurchargeFields[],
//   ciFuelSurchargeLookups: ClientInvoiceFuelSurchargeLookup[],
//   ciPeakSurcharges: UpdatePeakSurcharge[]
// ): CiRateCardRequest => {
//   // handle RATECARD VALUES
//   const ratecard: CiRateCardRequest = {
//     baseRate: uiRequest.baseRate !== undefined ? uiRequest.baseRate : 0,
//     variableRate:
//       uiRequest.variableRate !== undefined ? uiRequest.variableRate : 0,
//     variableRateType: uiRequest.variableRateType,
//     routeMinimum:
//       uiRequest.routeMinimum !== undefined ? uiRequest.routeMinimum : 0,
//     lateCancellationCharge:
//       uiRequest.lateCancellationCharge !== undefined
//         ? uiRequest.lateCancellationCharge
//         : 0,
//     lateCancellationType: uiRequest.lateCancellationType,
//     fuelType:
//       uiRequest.show_fuel_surcharge && !uiRequest.fuel_surcharge_custom_value
//         ? uiRequest.fuelType
//         : undefined,
//     regionName:
//       uiRequest.show_fuel_surcharge && !uiRequest.fuel_surcharge_custom_value
//         ? uiRequest.regionName
//         : undefined,
//     ratecardFuelSurchargeFields: ciFuelSurchargeFields,
//     ratecardFuelSurchargeLookup: ciFuelSurchargeLookups,
//     ratecardPeakSurcharges: ciPeakSurcharges,
//     discountCustomValue: uiRequest.show_discount
//       ? uiRequest.discount_custom_value
//       : undefined,
//     fuelCustomValue: uiRequest.show_fuel_surcharge
//       ? uiRequest.fuel_surcharge_custom_value
//       : undefined,
//     peakCustomValue: uiRequest.show_peak_surcharge
//       ? uiRequest.peak_surcharge_custom_value
//       : undefined,
//   };

//   // handle discounts
//   if (uiRequest.show_discount) {
//     ratecard.discountType =
//       uiRequest.discount_type === "volume"
//         ? "volume"
//         : uiRequest.discount_rate_type;
//     // handle volume discount
//     if (uiRequest.discount_type === "volume") {
//       ratecard.discountMinVolumeRate = uiRequest.discount_volume_min_unit;
//       ratecard.discountFrequency = mapFrequencyTextToNumber(
//         `${uiRequest.discount_volume_frequency}`
//       );
//       if (uiRequest.discount_volume_unit_type === "percentage") {
//         ratecard.discountUnitType = "percentage";
//         ratecard.discountValue = uiRequest.discount_volume_value_percentage;
//       } else {
//         ratecard.discountUnitType = "value";
//         ratecard.discountValue = uiRequest.discount_volume_value_dollar;
//       }
//     }
//     // handle rate discount
//     else if (uiRequest.discount_type === "rate") {
//       ratecard.discountMinVolumeRate = uiRequest.discount_rate_min_unit;

//       ratecard.discountFrequency = mapFrequencyTextToNumber(
//         `${uiRequest.discount_rate_frequency}`
//       );
//       if (uiRequest.discount_rate_unit_type === "percentage") {
//         ratecard.discountUnitType = "percentage";
//         ratecard.discountValue = uiRequest.discount_rate_value_percentage;
//       } else {
//         ratecard.discountUnitType = "value";
//         ratecard.discountValue = uiRequest.discount_rate_value_dollar;
//       }
//     }
//   }

//   return ratecard;
// };

export const mapFrequencyTextToNumber = (frequency: string): number => {
  return frequency === "weekly" ? 7 : frequency === "bi-weekly" ? 14 : 30;
};

export const mapFrequencyNumberToText = (
  frequency: number | undefined
): string => {
  if (frequency === undefined) return "";
  return frequency === 7
    ? "weekly"
    : frequency === 14
    ? "bi-weekly"
    : "monthly";
};

// This function takes a date and a list of usedDateRanges and returns true if the date is already used up.
// If already used up then the date must be disabled in the calendar and not let the user select that date.
export const isDisabledDate = (date: Date, usedDateRanges: Date[][]) => {
  let isDisabled = false;
  usedDateRanges &&
    usedDateRanges.length > 0 &&
    usedDateRanges.every((usedDateRange) => {
      // we want to set isDisabled to true and break if the date is in the min-max date range
      // So, we need to use every() because there is no way to break out of a forEach() loop
      // when using every() return true if you want to break else return false

      const minDate = usedDateRange[0];
      const maxDate = usedDateRange[1];

      date.setHours(0, 0, 0, 0);
      minDate.setHours(0, 0, 0, 0);
      maxDate.setHours(0, 0, 0, 0);

      if (date >= minDate && date <= maxDate) {
        isDisabled = true;
        return false;
      }
      return true;
    });
  return isDisabled;
};

// This function takes a master date range and a list of usedDateRanges and returns true if the date is already used up.
// If already used up then the field must be disabled.
export const isDisabledFieldDueToDateRangeEdits = (
  masterStartDate: Date,
  masterEndDate: Date,
  usedDateRanges: Date[][]
) => {
  let isDisabled = false;
  usedDateRanges &&
    usedDateRanges.length > 0 &&
    usedDateRanges.every((usedDateRange) => {
      // we want to set isDisabled to true and break if the date is in the min-max date range
      // So, we need to use every() because there is no way to break out of a forEach() loop
      // when using every() return true if you want to break else return false

      const minDate = usedDateRange[0];
      const maxDate = usedDateRange[1];

      masterStartDate.setHours(0, 0, 0, 0);
      masterEndDate.setHours(0, 0, 0, 0);
      minDate.setHours(0, 0, 0, 0);
      maxDate.setHours(0, 0, 0, 0);

      if (masterStartDate <= minDate && minDate <= masterEndDate) {
        isDisabled = true; // b starts in a
        return false;
      }
      if (masterStartDate <= maxDate && maxDate <= masterEndDate) {
        isDisabled = true; // b ends in a
        return false;
      }
      if (minDate < masterStartDate && masterEndDate < maxDate) {
        isDisabled = true; // a in b
        return false;
      }

      return true;
    });
  return isDisabled;
};

export const getSimpleFieldDateRangeEdits = (
  uiRequest: EditClientInvoiceUIRequest
): SimpleValueDateRangeType[] => {
  let base_rate_list: SimpleValueDateRangeType[] = [];
  if (uiRequest.base_rate_date_range_values.length > 0) {
    // uiRequest.base_rate_date_range_values.forEach((item) => {
    //   const base_rate: SimpleValueDateRangeType = {
    //     fieldName: "baseRate",
    //     fieldValue: item.value,
    //     fieldType: item.type,
    //     startDate: formatDate(item.date_range[0].toDate()),
    //     endDate: formatDate(item.date_range[1].toDate()),
    //   };
    //   base_rate_list = [...base_rate_list, base_rate];
    // });
    base_rate_list = uiRequest.base_rate_date_range_values;
  }

  let variable_rate_list: SimpleValueDateRangeType[] = [];
  if (uiRequest.variable_rate_date_range_values.length > 0) {
    // uiRequest.variable_rate_date_range_values.forEach((item) => {
    //   const variable_rate: SimpleValueDateRangeType = {
    //     fieldName: "variableRate",
    //     fieldValue: item.value,
    //     fieldType: item.type,
    //     startDate: formatDate(item.date_range[0].toDate()),
    //     endDate: formatDate(item.date_range[1].toDate()),
    //   };
    //   variable_rate_list = [...variable_rate_list, variable_rate];
    // });
    variable_rate_list = uiRequest.variable_rate_date_range_values;
  }

  let route_minimum_list: SimpleValueDateRangeType[] = [];
  if (uiRequest.route_minimum_date_range_values.length > 0) {
    // uiRequest.route_minimum_date_range_values.forEach((item) => {
    //   const route_minimum: SimpleValueDateRangeType = {
    //     fieldName: "routeMinimum",
    //     fieldValue: item.value,
    //     fieldType: item.type,
    //     startDate: formatDate(item.date_range[0].toDate()),
    //     endDate: formatDate(item.date_range[1].toDate()),
    //   };
    //   route_minimum_list = [...route_minimum_list, route_minimum];
    // });
    route_minimum_list = uiRequest.route_minimum_date_range_values;
  }

  let late_cancellation_list: SimpleValueDateRangeType[] = [];
  if (uiRequest.late_cancellation_date_range_values.length > 0) {
    // uiRequest.late_cancellation_date_range_values.forEach((item) => {
    //   const late_cancellation: SimpleValueDateRangeType = {
    //     fieldName: "lateCancellationCharge",
    //     fieldValue: item.value,
    //     fieldType: item.type,
    //     startDate: formatDate(item.date_range[0].toDate()),
    //     endDate: formatDate(item.date_range[1].toDate()),
    //   };
    //   late_cancellation_list = [...late_cancellation_list, late_cancellation];
    // });
    late_cancellation_list = uiRequest.late_cancellation_date_range_values;
  }

  let result: SimpleValueDateRangeType[] = [
    ...base_rate_list,
    ...variable_rate_list,
    ...route_minimum_list,
    ...late_cancellation_list,
  ];

  return result;
};

export const getDeletedFieldDateRangeEdits = (
  simpleValueDateRangeList: SimpleValueDateRangeType[],
  savedFieldEdits: SimpleValueDateRangeType[],
  discountDateRangeEdits: DiscountDateRangeValue[],
  savedDiscountDateRangeEdits: DiscountDateRangeValue[],
  fuelSurchargeDateRangeEdits: FuelSurchargeDateRangeValue[],
  savedFsDateRangeEdits: FuelSurchargeDateRangeValue[]
): DeleteFieldEditType[] => {
  const result: DeleteFieldEditType[] = [];
  const simpleFieldIdList = simpleValueDateRangeList
    .filter((item) => item.id !== undefined)
    .map((item) => item.id);

  savedFieldEdits.forEach((item) => {
    if (item.id && !simpleFieldIdList.includes(item.id)) {
      let resultItem: DeleteFieldEditType | undefined = result.find(
        (deleteRequest) => deleteRequest.id === item.id
      );

      if (resultItem)
        resultItem.fieldNames = [...resultItem.fieldNames, item.fieldName];
      else result.push({ id: item.id, fieldNames: [item.fieldName] });
    }
  });

  const discountIdList = discountDateRangeEdits
    .filter((item) => item.id !== undefined)
    .map((item) => item.id);

  savedDiscountDateRangeEdits.forEach((item) => {
    if (item.id && !discountIdList.includes(item.id)) {
      let resultItem: DeleteFieldEditType | undefined = result.find(
        (deleteRequest) => deleteRequest.id === item.id
      );

      if (resultItem)
        resultItem.fieldNames = [...resultItem.fieldNames, "discount"];
      else result.push({ id: item.id, fieldNames: ["discount"] });
    }
  });

  const fsIdList = fuelSurchargeDateRangeEdits
    .filter((item) => item.id !== undefined)
    .map((item) => item.id);

  savedFsDateRangeEdits.forEach((item) => {
    if (item.id && !fsIdList.includes(item.id)) {
      let resultItem: DeleteFieldEditType | undefined = result.find(
        (deleteRequest) => deleteRequest.id === item.id
      );

      if (resultItem)
        resultItem.fieldNames = [...resultItem.fieldNames, "fuelSurcharge"];
      else result.push({ id: item.id, fieldNames: ["fuelSurcharge"] });
    }
  });

  return result;
};
